module.exports = __webpack_public_path__ + "media/images/lock-icon-ef892de45b565d73d2e5f9f56764a9de.svg";